import { useOutletContext } from "react-router-dom";
import ZapierComponent from "V2.0/HomePages/HomeIntegrations/Zapier";
import { IntegrationShell } from "../common/Shell";

export function ZapierIntegration() {
    const { isViewOnly } = useOutletContext();
    return (
        <IntegrationShell>
            <ZapierComponent isViewOnly={isViewOnly}/>
        </IntegrationShell>
    )
}